export default __webpack_public_path__ + "static/GT-Super-Display-Light-Italic-5e103b8de9ad693b7fde9515c8709a67.woff";